import { Button, Form, Input, Typography } from 'antd';
import React, { useEffect } from 'react';
import LilyButton from '../../../../../components/button/lily-button';
import { useClaimContext } from '../../component/claim-context';
import { useSelector } from 'react-redux';
import CopyInfoComponent from '../../../../../components/copay-info.component';

const SavingCard = (props) => {
    const user = useSelector((state) => state.authenticatedUser);
    const { caseType, setCurrentType } = props;
    const [form] = Form.useForm();
    const { Title, Text } = Typography;

    const { claimForm, setCurrent, setClaimForm, supportOptions, setSupportOptions } = useClaimContext();

    useEffect(() => {
        form.setFieldsValue({
            cardGroup: claimForm.copayCardInfo.cardGroup,
            memberId: claimForm.copayCardInfo.memberId,
        });
    }, [claimForm]);

    const handleSubmit = () => {
        setSupportOptions((prev) =>
            prev.map((item) =>
                item.value === caseType ? { ...item, checked: true } : item
            )
        );
        setCurrentType('')
    }

    return (
        <div className='d-flex flex-column gap-4'>
            <div className='d-flex flex-column'>
                <Title className='mb-2 main-title' level={3}>
                    Copay Card Member ID#
                </Title>
                <Text>
                    This is the copay card member ID# we have on file for your program.<br />Please review and confirm the details to continue.
                </Text>
            </div>
            <CopyInfoComponent data={user}/>
            <div className='d-flex flex-row justify-content-end mt-5'>
                <Button
                    style={{ width: '200px' }}
                    color="default"
                    variant="link"
                    onClick={() => setCurrentType('')}
                >
                    Back
                </Button>
                <LilyButton style={{ width: '200px' }} onClick={handleSubmit} text="Next" />
            </div>
        </div>
    )
}

export default SavingCard